import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { MessageBubbleComponent } from '../message-bubble/message-bubble.component';
import { HighlightDirective } from '../utils/highlight.directive';
import { ButtonComponent } from '../button/button.component';
import { LinkModule } from '@rogers/cdk/link';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MessageBubbleComponent,
    HighlightDirective,
    ButtonComponent,
    LinkModule,
  ],
  selector: 'ucx-dialog-message',
  templateUrl: './dialog-message.component.html',
  styleUrls: ['./dialog-message.component.scss'],
})
export class DialogMessageComponent {
  @Input() clickableLinks = [];
  @Input() isMessageTypeSame = false;
  @Input() isFeedbackMessage = false;
  @Input() isCannedResponseVisible = true;
  @Input() cannedResponses = [];
  @Input() cardText = '';
  @Input() isUserMessage = false;
  @Input() bubbleIndex = 0;

  @Input() onLinkClick;
  @Input() onCannedResponseClick;
  @Input() timeStamp = '';

  constructor(private domSanitizer: DomSanitizer) {}

  getCardHtml(): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(this.cardText);
  }

  onClickableLink = (bubbleEvent): void => {
    this.onLinkClick(bubbleEvent);
  };

  cannedResponseClick = (response): void => {
    this.onCannedResponseClick(response);
  };

  getCannedResponseButtonId(buttonIndex: number): string {
    const prefix = this.isFeedbackMessage
      ? 'va-chat-bubble-text-feedback-'
      : 'va-chat-bubble-link-';
    return `${prefix}${this.bubbleIndex}-${buttonIndex}`;
  }
}
